export class DateParser {
    public static parseDateTime = (date: string, isStart: boolean): string => {
        if (!date) {
            return "";
        }

        let newDate = new Date(date);

        return newDate.getFullYear() + "-"
            + ((newDate.getMonth() + 1).toString().length === 1 ? "0" : "") +
            + (newDate.getMonth() + 1) + "-"
            + (newDate.getDate().toString().length === 1 ? "0" : "")
            + (newDate.getDate()) + " "
            + (isStart ? "00:00:00" : "23:59:59");
    }

    public static parseDate = (date: string): string => {
        if (!date) {
            return "";
        }

        let newDate = new Date(date);

        return newDate.getFullYear() + "-"
            + ((newDate.getMonth() + 1).toString().length === 1 ? "0" + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)) + "-"
            + (newDate.getDate().toString().length === 1 ? "0" + (newDate.getDate()) : (newDate.getDate()));
    }
}